import React, { useState, useCallback, useEffect } from 'react';
import { Input } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import { debounce } from 'lodash';

import './HistoryLogSearch.scss';

type Props = {
	onSearchChange: (search: string) => void;
	color?: 'white' | 'grey-2';
};

const MIN_SEARCH_LENGTH = 3;

const HistoryLogSearch = ({ onSearchChange, color = 'white' }: Props) => {
	const { t } = useTranslation();
	const [inputValue, setInputValue] = useState('');

	const debouncedChange = useCallback(
		debounce((value: string) => {
			// Only fire on clear (empty) or when at/above the min length — keeps the
			// parent from refetching (and flashing the spinner) on sub-min input.
			if (value.length === 0 || value.length >= MIN_SEARCH_LENGTH) {
				onSearchChange(value);
			}
		}, 500),
		[onSearchChange]
	);

	useEffect(() => {
		return () => {
			debouncedChange.cancel();
		};
	}, [debouncedChange]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setInputValue(value);
		debouncedChange(value);
	};

	return (
		<Input
			className="HistoryLogSearch"
			color={color}
			noborder
			icon="search"
			maxLength={256}
			value={inputValue}
			onChange={handleChange}
			placeholder={t('default.search')}
		/>
	);
};

export default HistoryLogSearch;
